
import PublicAppContainer from 'app_components/layouts/public'
import React, { useCallback, useEffect, useState } from 'react'
import FilterCourseCard from './components/FilterCourseCard/FilterCourseCard';
import FilterCourseCharacteristics from './components/FilterCourseCharacteristics/FilterCourseCharacteristics';
import FilterCoursePagination from './components/FilterCoursePagination/FilterCoursePagination';
import './AcademicFilterScreen.scss'
import { CiFilter } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import CourseService from 'app_services/campus/academic/courseService';
import { ICourse } from 'app_types/campus/academic/courseTypes';
import moment from 'moment';
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper';
import { ArrayParam, StringParam, useQueryParams } from 'use-query-params';
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes';

const PER_PAGE = 12

const AcademicFilterScreen = () => {

  const [show, setShow] = useState(false);
  const [courses, setCourses] = useState<ICourse[]>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [total, setTotal] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [query] = useQueryParams({
    search: StringParam,
    startDate: StringParam,
    endDate: StringParam,
    filterCategories: ArrayParam,
    mode: ArrayParam,
  })

  const showFilter = () => {
    setShow(true);
  }

  const hideFilter = () => {
    setShow(false);
  }


  const getCourses = useCallback(async () => {
    setIsLoading(true)
    const courseService = new CourseService()
    const response = await courseService.fetchCourses({
      endPublicationDate: {date: "today", direction: "gte"},
      startPublicationDate: {date: "today", direction: "lte"},
      nPerPage: PER_PAGE,
      pageNumber: pageNumber,
      publish: true,
      search: query.search,
      mode: query.mode,
      filterCategories: query.filterCategories,
      startDate: query.startDate ? {date: query.startDate, direction: "gte"} : undefined,
      endDate: query.endDate ? {date: query.endDate, direction: "lte"} : undefined,
      sort: {
        field: 'startDate',
        direction: '1'
      }
    })

    if(response){
      setCourses(response.courses)
      setTotal(response.total_register)
    } else {
      setCourses([])
      setTotal(0)
    }
    setIsLoading(false)
  }, [pageNumber, query])


  useEffect(() => {
    getCourses()
  }, [getCourses])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <PublicAppContainer>
      <div className='academic-filter-screen--container'>
        <div className='academic-filter-screen--container-filter'>
          <FilterCourseCharacteristics defaultOpen />
        </div>
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <h1 className='academic-filter-screen--layout'>Programación de cursos y diplomados ICONTEC</h1>
          <p style={{fontSize: '24px', fontWeight: 700, color:'var(--secondary)', padding: '0px 20px'}}>Línea abierta</p>
          <button onClick={showFilter} className='academic-filter-screen--button-filter'>Filtrar <CiFilter size={28} /></button>
          <LoadingWrapper loading={isLoading} >
            <div className='academic-filter-screen--container-cards'>
              {courses.map((course) => {
                return (
                  <FilterCourseCard
                    modality={course.schedulingMode?.name}
                    name={course.program?.name}
                    startDate={moment(course.startDate?.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY')}
                    duration={course.duration}
                    key={course._id}
                    slug={course?.extra_info?.slug as string}
                    courseId={course._id}
                    image={course.extra_info?.coverUrl}
                    schedule={course.schedule}
                    serviceInformation={course?.serviceInformation}
                    withoutTutor={course?.withoutTutor}
                    formationType={course?.extra_info?.formationType}
                    quickLearning={course?.quickLearning}
                    isMooc={course?.typeCourse === CourseSchedulingCourseType.MOOC}
                  />
                )
              })}
            </div>
          </LoadingWrapper>
          <div style={{ marginTop: 'auto' }}>
            <FilterCoursePagination
              pageNumber={pageNumber}
              total={total}
              perPage={PER_PAGE}
              onChangePage={setPageNumber}
            />
          </div>
        </div>
        <div className={'academic-filter-screen--movil-filter-container ' + (show ? '' : 'close')}>
          <IoClose size={23} color='var(--secondary)' cursor={'pointer'} onClick={hideFilter}/>
          <FilterCourseCharacteristics/>
        </div>
      </div>

    </PublicAppContainer>
  )
}

export default AcademicFilterScreen

